import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from 'vuex';
import { RootState } from '../types';
import moment from 'moment-timezone';

export interface MaintenancePeriod {
  year: number;
  month: number;
  date: number;
  hour: number;
  minute: number;
}

export type State = {
  isMaintenance: boolean;
  start: MaintenancePeriod | null;
  end: MaintenancePeriod | null;
  title: string;
  message: string;
};

function createState(): State {
  const state: State = {} as State;
  clearState(state);
  return state;
}

function clearState(state: State): void {
  state.isMaintenance = false;
  state.start = null;
  state.end = null;
  state.title = '';
  state.message = '';
}

const getters: GetterTree<State, RootState> = {};

const mutations: MutationTree<State> = {
  setMaintenance(state, payload: boolean): void {
    state.isMaintenance = payload;
  },

  setStart(state, payload: { date: string | null }): void {
    if (payload.date) {
      const momentDate: moment.Moment = moment(payload.date);
      state.start = {
        year: momentDate.get('year'),
        month: momentDate.get('month') + 1,
        date: momentDate.get('date'),
        hour: momentDate.get('hour'),
        minute: momentDate.get('minute')
      };
    } else {
      state.start = null;
    }
  },

  setEnd(state, payload: { date: string | null }): void {
    if (payload.date) {
      const momentDate: moment.Moment = moment(payload.date);
      state.end = {
        year: momentDate.get('year'),
        month: momentDate.get('month') + 1,
        date: momentDate.get('date'),
        hour: momentDate.get('hour'),
        minute: momentDate.get('minute')
      };
    } else {
      state.end = null;
    }
  },

  setTitle(state, payload: { title: string | null }): void {
    state.title = payload.title || '';
  },

  setMessage(state, payload: { message: string | null }): void {
    state.message = payload.message || '';
  },

  clearState(state: State): void {
    clearState(state);
  }
};

const actions: ActionTree<State, RootState> = {
  clearState(context: ActionContext<State, RootState>): void {
    context.commit('clearState');
  }
};

export const maintenance: Module<State, RootState> = {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions
};
